export const SET_HOFLAGE = "setHoflage";
export const SET_BETRIEBSZWEIGE = "setBetriebszweige";
export const SET_BEWIRTSCHAFTUNGSARTEN = "setBewirtschaftungsarten";
export const SET_TIERE = "setTiere";
export const SET_NEBENBETRIEBE = "setNebenbetriebe";
export const SET_EINSATZHERKUNFT_JUGENDLICHE = "setEinsatzherkunftJugendliche";
export const SET_AUSWAHL_EINSATZBEREICH = "setAuswahlEinsatzbereich";
export const SET_SANITAEREINRICHTUNGEN = "setSanitaereinrichtungen";
export const SET_VOUCHERSTATUS = "setVoucherStatus";

